import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
   TextField,
   Checkbox,
   FormControlLabel,
   Typography
} from '@material-ui/core';

import {DropzoneArea} from 'material-ui-dropzone'

import {
    currentLanguage,
    t,
} from "src/shared_modules/i18n";

import CountrySelect from "./country-select";
import FoaSelect from "./foa-select";
import PhoneInput from "./phone-input";

import LinkInText from "src/shared_modules/veu-visitors-core/components/common/link-in-text";

const WILDCARD_NONE = /none/g;
const WILDCARD_TITLE = /title/g;
const WILDCARD_USERNAME = /username/g;
const WILDCARD_FORMOFADRESS = /formOfAdress/g;
const WILDCARD_FIRSTNAME = /firstname/g;
const WILDCARD_LASTNAME = /lastname/g;
const WILDCARD_EMAIL = /email/g;
const WILDCARD_COMPANY = /company/g;
const WILDCARD_POSITION = /position/g;
const WILDCARD_COUNTRY = /country/g;
const WILDCARD_CITY = /city/g;
const WILDCARD_PHONE = /phone/g;
const WILDCARD_ABOUTME = /aboutme/g;


const parseDefaultValue = (defaultValue, user) => {
    if( !defaultValue )
        return "";

    if( !user.loggedIn )
        return "";

    let parsedDefaultValue = defaultValue
        .replace(WILDCARD_NONE, "")
        .replace(WILDCARD_USERNAME, user.username)
        .replace(WILDCARD_TITLE, user.profile.title)
        .replace(WILDCARD_FORMOFADRESS, user.profile.formOfAdress)
        .replace(WILDCARD_FIRSTNAME, user.profile.firstname)
        .replace(WILDCARD_LASTNAME, user.profile.lastname)
        .replace(WILDCARD_EMAIL, user.profile.email)
        .replace(WILDCARD_COMPANY, user.profile.company)
        .replace(WILDCARD_POSITION, user.profile.position)
        .replace(WILDCARD_COUNTRY, user.profile.country)
        .replace(WILDCARD_CITY, user.profile.city)
        .replace(WILDCARD_PHONE, user.profile.phone)
        .replace(WILDCARD_ABOUTME, user.profile.aboutme);

    return parsedDefaultValue;
}

// call this by a parent within componentDidMount !
const initFieldState = ( def, user ) => {
    // messagebox aka comment
    if( def.valueType === "messagebox" )
        return "";

    // note has no value
    // so there is no entry in parents state.fields for it
    if( def.valueType === "note" )
        return null;

    // checkbox is always false by default
    if( def.valueType === "checkbox" )
        return false;

    if( def.valueType === "uploadImage" )
        return null;

    if( !user.loggedIn ) {
        // otherwise the form field is undefined
        if( def.valueType === "formOfAdress" )
            return "4";

        if( def.valueType === "country")
            return "Germany";

        if( def.valueType === "checkbox" )
            return "+49";
    }

    return parseDefaultValue( def.defaultValue, user);
}

class FormControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showText: false
        }
        this.handleOnChange = this.handleOnChange.bind(this);
        this.getLabel = this.getLabel.bind(this);
        this.loadFile = this.loadFile.bind(this);
    }

    componentDidMount() {
        // just fail saves to show the user that something is not correct
        if( !this.props.def ) {
            console.error("FormControl didMount - def undefined ");
            return;
        }

        if( !this.props.def.name ) {
            console.error("FormControl didMount - def.name undefined ");
            return;
        }

        if( !this.props.def.label && !this.props.label ) {
            console.error("FormControl didMount - def.label and props.label is undefined! One must be set ");
            return;
        }
    }

    getLabel(lang) {
        let label = "";

        if( this.props.label )
            label = t(this.props.label);

        if( this.props.def.label )
            label = this.props.def.label[lang];

        return label;
    }

    loadFile( file ) {
        if( !file ) {
            this.props.onChange(null, this.props.def.name, null);
            return;
        }
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            this.props.onChange(null, this.props.def.name,
                {
                    data: reader.result,
                    name: file.path
                }
            );
        };

        reader.onerror = function (error) {
            this.props.onChange(null, this.props.def.name, null);
            console.error('Error: ', error);
        }
    }

    handleOnChange( e ) {
        if( this.props.def.valueType === "checkbox" ) {
            this.props.onChange(e, this.props.def.name, e.target.checked);
        } else if( this.props.def.valueType === "phone" ) {
            this.props.onChange(null, this.props.def.name, e);
        } else if( this.props.def.valueType === "uploadImage" ) {
            this.loadFile(e[0]);
        } else {
            this.props.onChange(e, this.props.def.name, e.target.value);
        }
    }

    renderTextField(lang, type = "") {
        let def = this.props.def;

        return( <TextField id={def.name} key={def.name}
                    required={def.isMandatory}
                    disabled={def.isReadOnly}
                    style={this.props.style}
                    className={this.props.className}
                    fullWidth
                    label={this.getLabel(lang)}
                    variant="outlined"
                    type={type}
                    value={this.props.value}
                    error={this.props.error}
                    onChange={this.handleOnChange}
                />);
    }

    renderFormOfAdress() {
        let def = this.props.def;

        return( <FoaSelect
                    required={def.isMandatory}
                    disabled={def.isReadOnly}
                    style={this.props.style}
                    className={this.props.className}
                    value={this.props.value}
                    error={this.props.error}
                    onChange={this.handleOnChange}
            />);
    }

    renderCountry(lang) {
        let def = this.props.def;

        return( <CountrySelect
                    required={def.isMandatory}
                    disabled={def.isReadOnly}
                    style={this.props.style}
                    className={this.props.className}
                    value={this.props.value}
                    error={this.props.error}
                    onChange={this.handleOnChange}
            />);
    }

    renderPhone(lang) {
        let def = this.props.def;

        return( <PhoneInput
                    required={def.isMandatory}
                    disabled={def.isReadOnly}
                    style={this.props.style}
                    className={this.props.className}
                    value={this.props.value}
                    error={this.props.error}
                    onChange={this.handleOnChange}
            />);
    }

    renderNote(lang) {
        let lbl = this.getLabel(lang);

        return(<Typography variant="caption" component="div" className="light-grey-text">
                {lbl}
        </Typography>);
    }

    renderCheckBoxLabel(lang) {
        let lbl = this.getLabel(lang);

        let variant = "body1";
        if( this.props.def.labelSize === "small" )
            variant="caption";

        return (<Typography variant={variant}>
                <LinkInText label={lbl} />
            </Typography>);
    }

    renderCheckBox(lang) {
        let def = this.props.def;

        let style = {}
        if( this.props.style)
            style = this.props.style;

        style.display = "table";

        return (<FormControlLabel id={def.name} key={def.name}
                    style={style}
                    className={this.props.className}
                    labelPlacement="end"
                    fontSize="11"
                    control={<div style={{display:'table-cell'}}>
                            <Checkbox checked={this.props.value}
                                required={def.isMandatory}
                                disabled={def.isReadOnly}
                                onChange={this.handleOnChange}
                                name={def.name}
                                color="secondary"
                            />
                    </div>}
                    label={ this.renderCheckBoxLabel(lang) }
                />);
    }

    renderMessageBox(lang) {
        let def = this.props.def;
        let lbl = this.getLabel(lang);

        return(<TextField
                    multiline={true}
                    variant="outlined"
                    fullWidth={true}
                    label={lbl}
                    inputProps={{ maxLength: 500 }}
                    maxRows="3"
                    disabled={def.isReadOnly}
                    style={this.props.style}
                    className={this.props.className}
                    value={this.props.value}
                    onChange={this.handleOnChange}
                />);
    }

    renderImageUpload(lang) {
        let def = this.props.def;
        let lbl = this.getLabel(lang);

        let inputProps={
            id : def.name,
            name : def.name,
        }

        return ( <DropzoneArea
                    acceptedFiles={['image/png,image/gif,image/jpeg']}
                    dropzoneText={lbl}
                    inputProps={inputProps}
                    filesLimit={1}
                    maxFileSize={3000000}
                    onChange={this.handleOnChange}
                    onDelete={this.handleOnChange}
                    showAlerts={false}
                />);
    }

    render() {
        if( !this.props.def ) {
            return (null);
        }

        if( !this.props.def.name ) {
            return (null);
        }

        if( !this.props.def.label && !this.props.label ) {
            return (null);
        }

        let currentLangi18n = currentLanguage().code2;
        switch( this.props.def.valueType ) {
            case "string":
                return this.renderTextField(currentLangi18n);
            case "hidden":
                return null;
            case "checkbox":
                return this.renderCheckBox(currentLangi18n);
            case "email":
                return this.renderTextField(currentLangi18n, "email");
            case "country":
                return this.renderCountry(currentLangi18n);
            case "formOfAdress":
                return this.renderFormOfAdress(currentLangi18n);
            case "phone":
                return this.renderPhone(currentLangi18n);
            case "note":
                return this.renderNote(currentLangi18n);
            case "messagebox":
                return this.renderMessageBox(currentLangi18n);
            case "uploadImage":
                return this.renderImageUpload(currentLangi18n);
            default:
                console.error("FormControl - unkown valueType: " + this.props.def.valueType);
                return null;
        }
    }
}

/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
FormControl.propTypes = {
    user : PropTypes.object
};

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
 const mapStateToProps = ( state, ownProps ) => {
     return {
         user: state.user,
         lang: state.system.currentLang, // must be mapped to trigger the language change for rerendering
     };
 };

const mapDispatchToProps = {

};


/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps,
    )(FormControl);

export { initFieldState }
